"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noElement = void 0;
function noElement(collection) {
    if (!collection)
        return true;
    if (Array.isArray(collection))
        return collection.length === 0;
    if (collection instanceof Set || collection instanceof Map)
        return collection.size === 0;
    if (typeof collection === "object")
        return Object.keys(collection).length === 0;
    return false;
}
exports.noElement = noElement;
//# sourceMappingURL=noElement.js.map